import SubflowStatusEnum from '@/stores/lead-aanvraag/SubflowStatus.enum.js';
import { useLeadAanvraagStore } from '@/stores/lead-aanvraag/lead-aanvraag';

export function updateCurrentSubflowState(status, isFlowOpener, currentSubflowNaam) {
  const leadAanvraagStore = useLeadAanvraagStore();

  var statusToUpdate;
  if (status !== null && status !== undefined) {
    statusToUpdate = status;
  } else if (isFlowOpener) {
    statusToUpdate = SubflowStatusEnum.Open;
  }

  if (statusToUpdate === null || statusToUpdate === undefined) return;
  const index = leadAanvraagStore.leadAanvraag.subflowState.findIndex(
    (subflow) => subflow.subflowNaam === currentSubflowNaam
  );

  if (index >= 0) {
    leadAanvraagStore.setValueOnLeadAanvraag({
      contentLocator: `subflowState.[${index}].subflowStatus`,
      value: statusToUpdate
    });
  }
}
